import { HttpInterceptorFn } from '@angular/common/http';
import { environment } from '../../../environments/environment';

export const setHeadersInterceptor: HttpInterceptorFn = (request, next) => {
  let headers = request.headers.append('Accept', ['application/json', 'application/ld+json']);
  headers = headers.append('Accept-Language', environment.locale);
  return next(request.clone({ headers }));
};
